import { GeneralFieldValues } from '@/pages/UserAccount/Profile';

import { genders } from '@/components/Forms/constants';

import { AuthContextInterface } from '@/contexts/Auth/AuthContext';

const defaultValues: GeneralFieldValues = {
  // Дані профілю
  lastName: '',
  firstName: '',
  middleName: '',
  birthday: '',
  gender: '',
  contactEmail: '',
  contactPhone: '',
};

export const buildGeneralDataDefaultValues = (authContext: AuthContextInterface): GeneralFieldValues => {
  return {
    ...defaultValues,
    firstName: authContext?.userData?.name_first ?? '',
    lastName: authContext?.userData?.name_last ?? '',
    middleName: authContext?.userData?.name_middle ?? '',
    birthday: authContext?.userData?.date_of_birth ?? '',
    contactPhone: authContext?.userData?.contact_phone ?? '',
    contactEmail: authContext?.userData?.contact_email ?? authContext?.userData?.email ?? '',
    gender:
      authContext?.userData?.gender === 'U'
        ? null
        : (genders.find(({ id }) => id === authContext?.userData?.gender) ?? null),
  };
};
